import { useLang } from "@/lib/LanguageContext";

export default function Services() {
    const { t } = useLang();

    return (
        <section
            id="offer"
            data-testid="services-section"
            className="py-20 lg:py-32 border-t border-hairline"
        >
            <div className="mx-auto max-w-screen-2xl px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-12 gap-8 md:gap-16 mb-16">
                    <div className="col-span-12 md:col-span-6">
                        <p className="overline text-terracotta mb-6">
                            {t.services.eyebrow}
                        </p>
                        <h2 className="font-serif text-5xl lg:text-7xl font-light tracking-tight text-navy">
                            {t.services.title}
                        </h2>
                    </div>
                    <p className="col-span-12 md:col-span-6 self-end max-w-xl text-navy/65 leading-relaxed">
                        {t.services.subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-hairline">
                    {t.services.items.map((s, idx) => (
                        <article
                            key={s.title}
                            data-testid={`service-card-${idx}`}
                            className="group relative border-b border-hairline lg:border-r p-8 md:p-10 lg:p-12 hover:bg-ivory-deep/40 transition-colors duration-500"
                        >
                            <div className="flex items-start justify-between mb-8">
                                <span className="eyebrow-num text-3xl">
                                    {String(idx + 1).padStart(2, "0")}
                                </span>
                                <span className="block w-8 h-px bg-navy/30 mt-4 group-hover:bg-terracotta group-hover:w-16 transition-all duration-500" />
                            </div>
                            <h3 className="font-serif text-2xl md:text-3xl font-light text-navy mb-4 leading-tight">
                                {s.title}
                            </h3>
                            <p className="text-navy/65 leading-relaxed">
                                {s.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
